import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import {
  setTokenInDisk,
  setTokenInMemory,
} from '@/utils/auth'
import store from '@/store'
import type {
  LoginFormData,
  UserInfo,
} from '@/api/user/type'
import * as UserAPI from '@/api/user'
import { Message as ElMessage } from 'element-ui'

export type RoleUnionStr = 'admin' | 'user'
export interface UserInfoCustom extends UserInfo {
  // role: RoleUnionStr
}

export interface IUserState {
  name: string;
  userInfo: UserInfoCustom;
}

export enum LoginStatusEnum {
  // 用户在当前 Tab 页已经登录过且 token 有效
  Login,
  // 用户在当前 Tab 页登录, 但是在其他 Tab 页中被注销且登陆了其他用户
  OtherUserHasLoginFromOtherTab,
  // 用户曾登录过, 但是 token 无效
  TokenInvalid,
  // 用户曾在当前 Tab 页登录过, 但是在其他 Tab 页中已经注销登录
  LogoutFromOtherTab,
  // 用户从未登录过
  NeverLogin,
}

@Module({ dynamic: true, store, name: 'user' })
class User extends VuexModule implements IUserState {
  public name = ''
  public userInfo: UserInfoCustom = {
    userId: '',
    // role: 'user',
    username:	'',
  }

  @Mutation
  private SET_NAME (name: string) {
    this.name = name
  }

  // @Mutation
  // public SET_ROLE (role: RoleUnionStr) {
  //   this.userInfo.role = role
  // }

  @Mutation
  private SET_USER_INFO (userInfo: UserInfoCustom) {
    this.userInfo = userInfo
  }

  @Action
  public async Login (params: LoginFormData) {
    const {
      data: token
    } = await UserAPI.login(params)
    setTokenInDisk(token)
    setTokenInMemory(token)
  }

  @Action
  public GetUserInfo () {
    return UserAPI.getUserInfo()
      .then(({ data }) => {
        this.SET_USER_INFO({
          // role: data.isAdmin ? 'admin' : 'user',
          ...data,
        })
      })
      .catch(() => {
        ElMessage.error('获取用户信息失败，请稍后重试')
      })
  }

  /**
   * 通过获取用户信息接口判断 token 是否有效
   * 如果有效则借助该接口对用户信息进行拉取
   * 如果失效则会通过在响应拦截器中抛异常
   * 1 次调用完成两件事情
   * @return {Promise<void>}
   * @constructor
   */
  @Action
  public GetUserInfo2CheckIsLogin () {
    return UserAPI.getUserInfo()
      .then(({ data }) => {
        this.SET_USER_INFO({
          // role: data.isAdmin ? 'admin' : 'user',
          ...data,
        })
      })
  }

  @Action
  public UpdateUserInfo (userInfo: UserInfoCustom) {
    console.log('UpdateUserInfo userInfo:', userInfo)
    this.SET_USER_INFO(userInfo)
  }

  @Action
  public async LogOut () {
    UserAPI.logout()
  }
}

export const UserModule = getModule(User)
